export const BASE_URL = "https://api.orderingspace.net";
export const token = "9j8h8hgjO0KUin3bhj58d97jiOh67f5h78hj78hg8vg5j63fo0h933";
export const liveUr="";
export const MapUrl="https://reactjs.orderingspace.net/cuisine/"